import { useMemo } from "react";
import { Datagrid, List, ReferenceField, ReferenceInput, SelectInput, TextField, TextInput } from "react-admin";
import { GenericColorChip } from "shared/components/chips/GenericColorChip";
import CustomDateField from "shared/components/fields/CustomDateField";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import {
  OptimizerCertificationStatusColorMapping,
  OptimizerGroupTypeColorMapping,
} from "shared/enums/colorMappings/optiColorMappings";
import { franceGroupTypeChoices, optimizerCertificationStatusChoices } from "shared/enums/reactAdminChoices";
import { OptimizerResourcesEnum } from "shared/enums/resourceMappings";

export default function GroupsCertificationsList() {
  const groupTypeChoices = useMemo(() => {
    return [...franceGroupTypeChoices, { id: "fingrid_site", name: "fingrid_site" }];
  }, []);
  const filters = useMemo(
    () => [
      <TextInput key="group_code" source="group_code" />,
      <TextInput key="name" source="name" />,
      <SelectInput key="group_type" label="Group Type" source="group_type" choices={groupTypeChoices} />,
      <SelectInput key="status" label="Status" source="status" choices={optimizerCertificationStatusChoices} />,
      <ReferenceInput
        key={"certification_id"}
        label="Certification Name"
        source="certification_id"
        reference={OptimizerResourcesEnum.OptiCertifications}
      />,
      <CustomDateTimeInput key="start_date__lte" label="Start Date <= " source="start_date__lte" />,
      <CustomDateTimeInput key="end_date__gt" label="End Date >= " source="end_date__gt" />,
    ],
    [groupTypeChoices],
  );

  return (
    <List filters={filters}>
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <CustomDateField source="start_date" showTime />
        <CustomDateField source="end_date" showTime />
        <GenericColorChip source="group_type" colorMapping={OptimizerGroupTypeColorMapping} />
        <TextField source="group_code" />
        <GenericColorChip source="status" colorMapping={OptimizerCertificationStatusColorMapping} />

        <ReferenceField
          label="Certification Name"
          source="certification_id"
          sortable={false}
          reference={OptimizerResourcesEnum.OptiCertifications}
          link={"show"}
        />
        <ReferenceField
          label="Market"
          source="certification_id"
          reference={OptimizerResourcesEnum.OptiCertifications}
          link="show"
        >
          <TextField source="market" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
}
